export default "__VITE_ASSET__CqUGRwgd__"